export interface SecondaryNavItem {
  key: string
  icon: string
  path: string
}

export const SECONDARY_NAV_ITEMS: SecondaryNavItem[] = [
  {
    key: 'secondaryNavigation.home',
    icon: '/icons/services/home.svg',
    path: '/home',
  },
  {
    key: 'secondaryNavigation.office',
    icon: '/icons/services/office-1.svg',
    path: '/office',
  },
  {
    key: 'secondaryNavigation.companyEvents',
    icon: '/icons/services/office.svg',
    path: '/corporate-clients',
  },
  {
    key: 'secondaryNavigation.events',
    icon: '/icons/services/festive.svg',
    path: '/events',
  },
  {
    key: 'secondaryNavigation.dispensers',
    icon: '/icons/services/wrench.svg',
    path: '/dispenser-service',
  },
  {
    key: 'secondaryNavigation.disinfect',
    icon: '/icons/services/spray.svg',
    path: '/disinfect',
  },
  {
    key: 'secondaryNavigation.promotions',
    icon: '/icons/services/discount.svg',
    path: '/offers',
  },
]

